import PricingHeader from '../components/PricingHeader';
import FeaturesTable from '../components/FeaturesTable';
import Footer from '../components/Footer';
import Header from '../components/Header';
import PricingTables from '../components/PricingTable';

export default function CrmPricing() {
  return (
    <>
      <PricingHeader />
      <PricingTables />
      <FeaturesTable />
    </>
  );
}